/**
 * The unit a client buys and spends, in client-facing words. Never say
 * "session" (or leak `class`/`course`) in copy. Not "video call" either —
 * the medium is not what a client counts.
 */
export function callNoun(count: number): string {
  return count === 1 ? 'call' : 'calls';
}

export function getTitle(
  title?: string,
  numberOfClasses?: number,
  isMeetPlan?: boolean
): string | null {
  if (title) return title;
  if (isMeetPlan) return 'Trial';
  if (numberOfClasses)
    return `${numberOfClasses} ${numberOfClasses === 1 ? 'booking' : 'bookings'}`;
  return null;
}

export function shouldShowFees(price?: { amount: number; currency: string }): boolean {
  return !!(price && price.amount > 0);
}

/**
 * The product categories we measure separately in analytics.
 * (`free_trial` existed until $0 orders were removed 2026-08-05 — every trial is paid
 * now; `exclusive_offers` until the lead card was removed 2026-08-06.)
 */
export type ProductKind = 'paid_trial' | 'one_on_one';

export function getProductKind(isTrial: boolean): ProductKind {
  return isTrial ? 'paid_trial' : 'one_on_one';
}

/** The storefront's trial bundle, if any — always claimable (every trial is a paid purchase). */
